/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchAccountsSimpleResponseItem } from './search-accounts-simple-response-item';


export interface SearchAccountsSimpleResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchAccountsSimpleResponseItem> | null;
}

